export const SETTAB = " SETTAB";
export const SETTABSTATE = " SETTABSTATE";